import React, { useState } from "react";
import { Container, Typography } from "@mui/material";
import "./Contact_me.css";

const Contact_me = () => {
  const [userMessage, setUserMessage] = useState({
    name: "",
    email: "",
    message: "",
    from: "Morshed_portfolio",
  });
  console.log(userMessage);
  const clear = () => {
    setUserMessage({ name: "", email: "", message: "" });
  };

  const handleSubmit = (event) => {
    fetch("https://fierce-scrubland-72229.herokuapp.com/client/userMessage", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(userMessage),
    }).then((res) => {
      console.log("res data", res);
      clear();
    });
    event.preventDefault();
  };

  const mailto = () => {
    window.open(
      "mailto:morshedhasan1969@gmail.com?subject=Subject&body=Body%20goes%20here"
    );
  };
  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Container>
        <div
          style={{
            marginTop: "1em",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div>
            <Typography
              variant="h4"
              style={{ color: "#fff", textAlign: "center" }}
            >
              Contact_us
            </Typography>

            <div style={{ marginTop: "1em" }}></div>
            <Typography variant="h6" style={{ color: "#fff" }}>
              Have you any questions? I 'd love to here from You.
            </Typography>
            <Typography variant="h6" style={{ color: "#fff" }}>
              For all enquiries, please email us using the from below
            </Typography>
            <div style={{ borderBottom: "2px solid #fff" }}></div>
          </div>
        </div>
        <div class="container">
          <div class="form-container front">
            {/* <h1 class="form-label">Material Design Form</h1> */}
            <form onSubmit={handleSubmit}>
              <div class="group">
                <input
                  type="text"
                  required
                  value={userMessage.name}
                  onChange={(e) =>
                    setUserMessage({ ...userMessage, name: e.target.value })
                  }
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Name</label>
              </div>
              <div class="group">
                <input
                  type="email"
                  required
                  value={userMessage.email}
                  onChange={(e) =>
                    setUserMessage({ ...userMessage, email: e.target.value })
                  }
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Email</label>
              </div>
              <textarea
                class="message-form-control"
                id="message"
                name="message"
                placeholder="Message"
                required
                rows="5"
                value={userMessage.message}
                onChange={(e) =>
                  setUserMessage({ ...userMessage, message: e.target.value })
                }
              ></textarea>
              <input
                type="submit"
                class="button-tow raised btn btn-primary btn-lg"
              />
            </form>
            <Typography>
              sending to{" "}
              <span
                className="contact-s-l-hover"
                sx={{ textDecoration: "none", color: "#0a192f" }}
                onClick={() => mailto()}
              >
                morshedhasan1969@gmail.com
              </span>
            </Typography>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Contact_me;
